module.exports = __webpack_public_path__ + "static/media/pdx.d795b547.jpg";